import { TransactionRequests } from '@/services/transactions.requests'

import Vue from 'vue'

const transactionService = new TransactionRequests()

const state = {
  list: [],
}

const actions = {
  list ({ commit }, { save, limit, offset, accountIds, guestId, stationId, type, currencyType, createdSince, createdUntil }) {
    return new Promise((resolve, reject) => {
      transactionService.list({ limit, offset, accountIds, guestId, stationId, type, currencyType, createdSince, createdUntil }).then((transactions) => {
        if (save) commit('setList', transactions)
        resolve(transactions)
      }).catch((error) => {
        reject(error)
      })
    })    
  },
}

const mutations = {
  setList (state, list) {
    Vue.set(state, 'list', list)
  },
  resetList (state) {
    Vue.set(state, 'list', null)
  },
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
}
